// All subscriptions related apis
import instance, { API_URL } from "./api";
import { encryptData } from "../helpers/encryptDecrypt";

// Get api for fetching all the active subscriptions plans
export const fetchSubscriptionPlans = async () => {
  return await instance.get(`${API_URL}/plans`);
};

// Get api for fetching all the active subscriptions features
export const fetchSubscriptionFeatures = async () => {
  return await instance.get(`${API_URL}/plans/all-features`);
};

// Get api for fetching organization's active subscriptions details
export const fetchOrganizationSubscriptionDetail = async (organization_id) => {
  const oId = encryptData(organization_id);
  return await instance.get(`${API_URL}/subscription-details/${oId}`);
};

// Post api for active organization to subscribe to a plan
export const subscribeToPlan = async (organization_id, data) => {
  const $oId = encryptData(organization_id);
  return await instance.post(`${API_URL}/subscribe/${$oId}`, data);
};

// Post api for active organization to unsubscribe to a plan
export const unSubscribeToPlan = async (organization_id) => {
  const $oId = encryptData(organization_id);
  return await instance.post(`${API_URL}/subscription-cancel/${$oId}`);
};

// Get api for fetching active organization's all subscriptions invoices
export const fetchOrganizationSubscriptionInvoices = async () => {
  return await instance.get(`${API_URL}/subscription-invoices`);
};

// Delete api for deleting selected invoice
export const deleteOrganizationSubscriptionInvoice = async (id) => {
  const sId = encryptData(id);
  return await instance.delete(`${API_URL}/subscription-invoices/${sId}`);
};
